module.exports = function() {
  return new Worker(__webpack_public_path__ + "932f95b2fba935ac01d9.worker.js");
};